import { render, staticRenderFns } from "./InstrumentDetails.vue?vue&type=template&id=dd9a2c2c&scoped=true"
import script from "./InstrumentDetails.vue?vue&type=script&lang=ts"
export * from "./InstrumentDetails.vue?vue&type=script&lang=ts"
import style0 from "./InstrumentDetails.vue?vue&type=style&index=0&id=dd9a2c2c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd9a2c2c",
  null
  
)

export default component.exports